export const SixDots = ({ width, height, viewBox, fill, styles }) => {
  return (
    <svg
      width={width || '21'}
      height={height || '20'}
      viewBox={viewBox || '0 0 21 20'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <path
        d="M8 7C7.17157 7 6.5 6.32843 6.5 5.5C6.5 4.67157 7.17157 4 8 4C8.82843 4 9.5 4.67157 9.5 5.5C9.5 6.32843 8.82843 7 8 7Z"
        fill={fill || '#BBBEC6'}
      />
      <path
        d="M8 11.5C7.17157 11.5 6.5 10.8284 6.5 10C6.5 9.17157 7.17157 8.5 8 8.5C8.82843 8.5 9.5 9.17157 9.5 10C9.5 10.8284 8.82843 11.5 8 11.5Z"
        fill={fill || '#BBBEC6'}
      />
      <path
        d="M8 16C7.17157 16 6.5 15.3284 6.5 14.5C6.5 13.6716 7.17157 13 8 13C8.82843 13 9.5 13.6716 9.5 14.5C9.5 15.3284 8.82843 16 8 16Z"
        fill={fill || '#BBBEC6'}
      />
      <path
        d="M13 7C12.1716 7 11.5 6.32843 11.5 5.5C11.5 4.67157 12.1716 4 13 4C13.8284 4 14.5 4.67157 14.5 5.5C14.5 6.32843 13.8284 7 13 7Z"
        fill={fill || '#BBBEC6'}
      />
      <path
        d="M13 11.5C12.1716 11.5 11.5 10.8284 11.5 10C11.5 9.17157 12.1716 8.5 13 8.5C13.8284 8.5 14.5 9.17157 14.5 10C14.5 10.8284 13.8284 11.5 13 11.5Z"
        fill={fill || '#BBBEC6'}
      />
      <path
        d="M13 16C12.1716 16 11.5 15.3284 11.5 14.5C11.5 13.6716 12.1716 13 13 13C13.8284 13 14.5 13.6716 14.5 14.5C14.5 15.3284 13.8284 16 13 16Z"
        fill={fill || '#BBBEC6'}
      />
    </svg>
  );
};
